<nav aria-label="breadcrumb">
  <ol class="breadcrumb horizontal-scroll">
    <ng-container *ngFor="let cat of breadcrumb; let isLast = last">
      <li 
        [ngClass]="{'breadcrumb-item': true, 'active': isLast}" 
        [routerLink]="cat.isProduct ? ['/product-details', cat.id] : ['/category', cat.id]" 
        [state]="{isViewAll: isViewAll}">
        <a (click)="isLast || navigateToCategory(cat.id)">
          <span style="color:#0D87C8; font-weight: bold;">{{ cat.name }}</span>
        </a>
      </li>
    </ng-container>
  </ol>
</nav>